import moment from 'moment';
import { VTS_ATTRIBUTES } from '../constants';

export const getLocalDateString = (date = new Date()) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const formatDateTimeWithOffset = (value) => {
	if (!value) return '';

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return '';

	const pad = (number) => String(number).padStart(2, '0');
	const offsetMinutes = -date.getTimezoneOffset();
	const sign = offsetMinutes >= 0 ? '+' : '-';
	const absoluteOffset = Math.abs(offsetMinutes);

	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${sign}${pad(Math.floor(absoluteOffset / 60))}:${pad(absoluteOffset % 60)}`;
};

export const formatZplTemplate = (template, partNumber) => {
	const now = moment();
	const date = now.format('YYYY-MM-DD');
	const time = now.format('HH:mm');

	return template
		.replace(/{PartNumber}/g, partNumber || '')
		.replace(/{VIN}/g, partNumber || '')
		.replace(/{Date}/g, date)
		.replace(/{Time}/g, time);
};

export const getErrorMessage = (err) => {
	if (err.response) {
		if (err.response.data && err.response.data.error) {
			return err.response.data.error;
		} else if (err.response.data && err.response.data.errors) {
			return err.response.data.errors;
		}
		return err.response.data;
	}
	return err.message;
};

export const CustomAxiosError = (message) => {
	return {
		response: {
			data: {
				message,
			},
		},
	};
};

export const getPartFamiliesToValidate = (scanJobDetails, sequenceNumber) => {
	// Add null/undefined check to prevent runtime errors
	if (!scanJobDetails || !Array.isArray(scanJobDetails)) {
		return [];
	}

	const rows = scanJobDetails
		.map((partDetails) => {
			return [...Array(partDetails.quantity)].map((_, index) => {
				const basicPartFamiliyDetails = {
					...partDetails,
					sequenceNumber,
					partPosition: index + 1,
				};

				if (partDetails.scanJobResults && partDetails.scanJobResults[index])
					return {
						...basicPartFamiliyDetails,
						...partDetails.scanJobResults[index],
						prevScannedValue: partDetails.scanJobResults[index].scannedValue,
						scanJobResultId: partDetails.scanJobResults[index].id,
					};
				return {
					...basicPartFamiliyDetails,
				};
			});
		})
		.flat(1)
		.map((part, index) => ({ ...part, id: index }));


	return rows;
};

export const getAttributeToValidate = (
	scanAttributeJobDetails,
	sequenceNumber,
) => {
	// Add null/undefined check to prevent runtime errors
	if (!scanAttributeJobDetails || !Array.isArray(scanAttributeJobDetails)) {
		return [];
	}

	const rows = scanAttributeJobDetails
		.filter((attribute) => !attribute.scannedValue)
		.filter((attribute) => !VTS_ATTRIBUTES.includes(attribute.attributeName))
		.map((attribute, index) => {
			return {
				...attribute,
				sequenceNumber,
				id: index,
			};
		});

	return rows;
};
